export const STATUS_LABEL = {
  CRITICAL: "Critical",
  THREATENED: "Threatened",
  WATCH: "Watch",
  RECOVERING: "Recovering",
  STABLE: "Stable",
};

export default function ConservationPill({ status, className = "" }) {
  const s = (status || "STABLE").toUpperCase();
  const map = {
    CRITICAL: "pill-critical",
    THREATENED: "pill-threatened",
    WATCH: "pill-watch",
    RECOVERING: "pill-recovering",
    STABLE: "pill-stable",
  };
  return (
    <span
      data-testid={`conservation-pill-${s.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 border rounded-full text-xs font-medium ${map[s]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s === "CRITICAL" ? "bg-red-500" : s === "THREATENED" ? "bg-orange-500" : s === "WATCH" ? "bg-amber-500" : s === "RECOVERING" ? "bg-emerald-500" : "bg-stone-400"}`} />
      {STATUS_LABEL[s] || s}
    </span>
  );
}
